module.exports = __webpack_public_path__ + "img/132x132_zulin@2x.0b429a94.png";